
import { LandmarkManagementView } from '../../Views/Home/LocationViews/LandmarkView/LandmarkManagementView/LandmarkManagementView';
import { LandmarkView } from '../../Views/Home/LocationViews/LandmarkView/LandmarkView';


export const LandmarksLocationsRoutes = [
  {
    path: '/view',
    name: 'LocationView:Landmarks',
    component: LandmarkView,
    layout: '/home/Landmarks',
    default: true,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'LocationView:Landmarks',
        isDisabled: false,
        route: '/home/Landmarks/view',
        groupName: 'LocationView:locations',
      },
    ],
  },
  {
    path: '/add',
    name: 'LocationView:add',
    component: LandmarkManagementView,
    layout: '/home/Landmarks',
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'LocationView:Landmarks',
        isDisabled: false,
        route: '/home/Landmarks/view',
        groupName: 'LocationView:locations',
      },
      {
        name: 'LocationView:add',
        isDisabled: false,
        route: '/home/Landmarks/add',

      },
    ],
  },
  {
    path: '/edit',
    name: 'LocationView:edit',
    component: LandmarkManagementView,
    layout: '/home/Landmarks',
    default: false,
    isRoute: true,
    authorize: true,
    roles: [],
    isDisabled: false,
    isExact: true,
    breadcrumbs: [
      {
        name: 'LocationView:Landmarks',
        isDisabled: false,
        route: '/home/Landmarks/view',
        groupName: 'LocationView:locations',
      },
      {
        name: 'LocationView:edit',
        isDisabled: false,
        route: '/home/Landmarks/edit',

      },

    ],
  },
];
